<template>
  <VExpansionPanels focusable>
    <BonLivraisonExpansionPanel :accounts="accounts" :users="users" />
    <BonRetourExpansionPanel :accounts="accounts" :users="users" />
    <BonInstallationExpansionPanel :accounts="accounts" :users="users" />
    <FichePreparationExpansionPanel :accounts="accounts" :users="users" />
    <FicheSignalementExpansionPanel :accounts="accounts" :users="users" />
  </VExpansionPanels>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import BonLivraisonExpansionPanel from "@/components/BonLivraisonExpansionPanel.vue";
import BonRetourExpansionPanel from "@/components/BonRetourExpansionPanel.vue";
import BonInstallationExpansionPanel from "@/components/BonInstallationExpansionPanel.vue";
import FichePreparationExpansionPanel from "@/components/FichePreparationExpansionPanel.vue";
import FicheSignalementExpansionPanel from "@/components/FicheSignalementExpansionPanel.vue";
import type { User } from "@/types";
import type { Account } from "@/types";
import { getAllAccounts } from "@/utils/account-api";
import { getAllUsers } from "@/utils/user-api";

/* ---------- Reactive state ---------- */
const accounts = ref<Account[]>([]);
const users = ref<User[]>([]);

/* ---------- Lifecycle ---------- */
onMounted(async () => {
  // Load accounts
  accounts.value = await getAllAccounts();

  // Load users and add "Autre"
  const fetchedUsers = await getAllUsers();
  const autreUser: User = {
    lastname: "personne",
    name: "Autre",
    technical: true,
  } as User;

  fetchedUsers.push(autreUser);

  // Keep only technical users
  users.value = fetchedUsers.filter((u) => u.technical);
});
</script>
